import { FunctionComponent } from 'react'
import { formatPrice } from '../src/utils/priceUtils'
import { Offer } from '../src/types'
import styles from './ProductOverview.module.css'

type Props = {
  offer: Offer
}

export const ProductOverview: FunctionComponent<Props> = ({ offer }) => (
  <div className="stack-l gap-s_3">
    <h1>{offer.itemOffered.name}</h1>
    <div className="flex flex-wrap items-center gap-s0">
      <span className={styles.price}>{formatPrice(offer)}</span>
      <span className={styles.shipping}>FREE Shipping</span>
    </div>
  </div>
)
